import axios from 'axios';
import { BASE_URL } from 'common/api/Constants';

export default axios.create({ baseURL: BASE_URL });
